import GraphqlGroupedBuilder from 'utils/request/graphql/groupedBuilder'
import QueryTimeslotKindExceptions from 'graphql/queries/QueryTimeslotKindExceptions'
import QueryTimeslotKindException from 'graphql/queries/QueryTimeslotKindException'
import { constantsActive } from 'utils/constants/constants'

const FetchTimeslotKindExceptions = {
	
	fetchAll: ( { timeslotKindGuid = null, callbackSuccess = null, callbackError = null, callbackStart = null } = {} ) => {
		GraphqlGroupedBuilder.addQuery( 'timeslot_kind_exceptions', QueryTimeslotKindExceptions, {
			variables: {
				timeslot_kind_guid: timeslotKindGuid,
				active: [
					constantsActive.YES,
					constantsActive.NO,
				]
			},
			resultPath: [ 'timeslot_kind_exceptions' ],
			callbackStart,
			callbackError,
			callbackSuccess,
		})
	},
	
	fetch: ( { guid = null, callbackSuccess = null, callbackError = null, callbackStart = null } = {} ) => {
		GraphqlGroupedBuilder.addQuery( 'timeslot_kind_exception', QueryTimeslotKindException, {
			variables: {
				guid: guid
			},
			resultPath: [ 'timeslot_kind_exception' ],
			callbackStart,
			callbackError,
			callbackSuccess,
		})
	},
}

export default FetchTimeslotKindExceptions
